import { render } from "./ClearUserData.vue?vue&type=template&id=2171393d&scoped=true"
import script from "./ClearUserData.vue?vue&type=script&lang=js"
export * from "./ClearUserData.vue?vue&type=script&lang=js"

import "./ClearUserData.vue?vue&type=style&index=0&id=2171393d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2171393d"]])

export default __exports__